<div class="payment-error" #paymentError fxLayout="column" fxLayoutAlign="center center">
  <i class="mdi mdi-alert"></i>
  <div translate>Payment Failed</div>
  <p translate>Please try again</p>
  <button mat-flat-button [color]="'primary'" (click)="goBack()">{{'Try Again'| translate}}</button>

</div>
